module.exports = __webpack_public_path__ + "static/img/RWB-52V2A.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/front/RWB-52V2A.png
// module id = 97Fw
// module chunks = 0